module.exports = __webpack_public_path__ + "img/3.608613a2.jpg";